import { Box } from '@chakra-ui/react';
import type { ReactNode } from 'react';

interface MessageSystemProps {
  children: ReactNode;
}

function MessageSystem({ children }: MessageSystemProps) {
  return (
    <Box
      className="MessageSystem fadeIn"
      color="fg"
      fontSize="xs"
      fontWeight="medium"
      lineHeight="normal"
      // textAlign="center"
      w="fit-content"
      mx="auto"
      bg="white"
      borderRadius="md"
      p="2"
      // alignItems="center"
    >
      {children}
    </Box>
  );
}

const MemoizedMessageSystem = memo(MessageSystem);
export { MemoizedMessageSystem as MessageSystem };
